export default __webpack_public_path__ + "static/media/Beans.826f5c3b.jpg";